import { Map } from "immutable";

const listToMap = list => (list ? list.reduce((map, obj) => map.set(obj.id, obj), Map()) : Map());

const updateMapIfNewValue = (map, propName, newValue) => {
  if (map.get(propName) !== newValue) {
    return map.set(propName, newValue);
  }
  return map;
};

const immutableUtils = { listToMap, updateMapIfNewValue };

export default immutableUtils;
